import React, { useEffect } from 'react';
import {
  resetToDefaultNavbarState,
  setNavbarWithTitleNoTopNavbar,
} from '@atom/navbarAtom';
import SubscriptionDashboard from '@components/subscription/list/SubscriptionDashboard';

const SubscriptionDashboardPage = () => {
  useEffect(() => {
    setNavbarWithTitleNoTopNavbar('Subscription');
    return () => {
      resetToDefaultNavbarState();
    };
  }, []);

  return <SubscriptionDashboard />;
};

export default SubscriptionDashboardPage;
